export default function initialDump(api) {
    return api && api.provideCall && api.provideCall('requestInitialDump', 'cancelInitialDumpRequest', {
        // topic to request
        rpcName: '/sports#initialDump',

        parseParams: ({ topic = '' }) => ({ topic }),

        // validation occurs before parsing
        validateResponse: (data) => data && data.kwargs && data.kwargs.version && data.kwargs.records,
    });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/rpc-initial-dump.js